import BaseHistoryRecordModel from '../BaseHistoryRecordModel';
import { HistoryRecordDto } from '../../services/types';

export default class ProjectAssignmentHistoryRecordModel extends BaseHistoryRecordModel {
    constructor(data: HistoryRecordDto) {
        super(data);
    }

    get assignmentObjectId() {
        const objectId = this.fields.find(field => field.name === 'UserId' || field.name === 'GroupId')?.value;
        return typeof objectId === 'string' ? objectId : undefined;
    }

    get isUserProjectAssignment() {
        return this.fields.find(field => field.name === 'Type' && field.value === 'user');
    }

    get objectLabel() {
        if (this.isUserProjectAssignment) {
            return 'User Project Assignment';
        }

        return 'Group Project Assignment';
    }
}
